import { Moment } from 'moment'

import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum VariablePriceSearchResultFields {
	searchById = 'searchById',
	searchByName = 'searchByName',
	searchByDescription = 'searchByDescription'
}

export enum VariablePriceFilterFields {
	includeInactive = 'includeInactive',
	priceChangeDate = 'priceChangeDate'
}

export declare namespace VariablePrice {
	interface Basic extends Entity {
		description: string
		isActive: boolean
		beginPriceRange: number
		endPriceRange: number
		priceChangeDate: string
	}

	interface Detailed extends Omit<Basic, 'priceChangeDate'> {}

	interface FormData {
		name: string
		description: string
		isActive: boolean
		beginPriceRange: string
		endPriceRange: string
	}

	namespace Rate {
		interface Basic {
			id: Key
			effectiveStartDate: string | null
			effectiveEndDate: string | null
			unitPrice: number | null
			modifiedBy: string
		}

		namespace Form {
			interface Generic {
				effectiveStartDate: Moment | null
				effectiveEndDate: Moment | null
				unitPrice: number | null
				month: number | null
			}
		}

		namespace Request {
			interface Generic {
				effectiveStartDate: string | null
				effectiveEndDate: string | null
				unitPrice: number | null
			}
		}
	}

	namespace Search {
		interface Result {
			[VariablePriceSearchResultFields.searchById]: Entity[]
			[VariablePriceSearchResultFields.searchByName]: string[]
			[VariablePriceSearchResultFields.searchByDescription]: string[]
		}

		interface Config {
			[VariablePriceSearchResultFields.searchById]: ConfigItem<VariablePriceSearchResultFields>
			[VariablePriceSearchResultFields.searchByName]: ConfigItem<VariablePriceSearchResultFields>
			[VariablePriceSearchResultFields.searchByDescription]: ConfigItem<VariablePriceSearchResultFields>
		}
	}

	namespace Filters {
		interface Config {
			[VariablePriceFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
			[VariablePriceFilterFields.priceChangeDate]: ConfigFilterItem<string, null>
		}
	}
}
